<script setup>
import { useAnalysisDataStore } from '@/store/modules/analysisDataStore'
import {
  parseKeywords,
  insertLineBreak,
  transformMarkedText,
  splitBySentence,
} from '@/composables/splitSentence'
import IconLike from '@/components/svg/IconLike.vue'

const analysisDataStore = useAnalysisDataStore()

// 직업추천 데이터를 분리한 computed 속성들
const generalJobFields = computed(() => analysisDataStore.yData?.분석상세?.종합분석 || {})

</script>

<template>
  <div
    v-if="generalJobFields && Object.keys(generalJobFields).length > 0"
    class="youngsin-total-analysis-box"
  >
    <!-- <h3 class="section-title">일반추천분야</h3> -->
    <div v-for="(text, title) in generalJobFields" :key="title" class="youngsin-total-analysis">
      <div class="tit">{{ title }}</div>
      <div class="txt" v-html="transformMarkedText(text, { keywordClass: 'y-keyword' })"></div>
    </div>
  </div>

  <div class="gap-large"></div>
</template>

<style lang="scss">
.youngsin-total-analysis-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.youngsin-total-analysis {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  margin-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 16px;
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
  .tit {
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 160% */
  }
  .txt {
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 160% */
    .txt-bold {
      font-weight: 500;
    }
  }
}
</style>
